import React, { useState, FormEvent } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Login.css';

interface LocationState {
  from?: { pathname: string };
}

export function Login() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const state = location.state as LocationState;
  const from = state?.from?.pathname || '/dashboard';

  // Redirect if already authenticated
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Convert to uppercase and limit to 4 characters
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4);
    setCode(value);
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    const trimmedCode = code.trim();
    if (!trimmedCode) {
      setError('Bitte geben Sie einen Code ein');
      setIsSubmitting(false);
      return;
    }

    if (trimmedCode.length !== 4) {
      setError('Der Code muss genau 4 Zeichen lang sein');
      setIsSubmitting(false);
      return;
    }

    const result = await login(trimmedCode);

    if (result.success) {
      navigate(from, { replace: true });
    } else {
      setError(result.error || 'Anmeldung fehlgeschlagen');
    }

    setIsSubmitting(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Schulungsportal</h1>
          <p>Bitte geben Sie Ihren 4-stelligen Zugangscode ein</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="code">Zugangscode</label>
            <input
              type="text"
              id="code"
              value={code}
              onChange={handleCodeChange}
              placeholder="XXXX"
              disabled={isSubmitting}
              autoFocus
              autoComplete="off"
              maxLength={4}
              style={{
                textTransform: 'uppercase',
                letterSpacing: '0.5rem',
                textAlign: 'center',
                fontSize: '1.5rem',
                fontFamily: 'monospace'
              }}
            />
          </div>

          <button type="submit" className="login-btn" disabled={isSubmitting || code.length !== 4}>
            {isSubmitting ? 'Anmelden...' : 'Anmelden'}
          </button>
        </form>

        <div className="login-footer">
          <p>Kontaktieren Sie Ihren Administrator, falls Sie keinen Code haben.</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
